import { Paper, Box } from '@mui/material';

const DashboardPanel = ({ children, sx = {} }) => {
  const { p, padding, ...paperSx } = sx;
  const innerPadding = p ?? padding ?? 1;
  return (
    <Paper 
      elevation={2} 
      sx={{ 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        overflow: 'hidden',
        borderRadius: 0,
        ...paperSx
      }}
    >
      <Box sx={{ flex: 1, p: innerPadding, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        {children}
      </Box>
    </Paper>
  );
};

export default DashboardPanel;
